import { createContext } from 'react';
import { ResolvedUrls } from '../../utils/resolver';

/**
 * Context Provider for cdnUrls:
 *
 * - serkoCdn
 * - zenoCdn
 * - webApiUrl
 * - robotoUrl
 * - robotoCondensedUrl
 */
export const CdnUrlProvider = createContext({
  serkoCdn: '',
  zenoCdn: '',
  webApiUrl: '',
  robotoUrl: '',
  robotoCondensedUrl: '',
} as ResolvedUrls);

CdnUrlProvider.displayName = 'CdnUrlProvider';
